// File: pages/SchemaMethodPage.jsx
import React from 'react';
import { Layout } from 'antd';
import GatewayFlowDiagram from "../components/GatewayFlowDiagram";
export default function SchemaMethodPage() {
    return (
        <Layout style={{ padding: 24 }}>
            <div style={{ padding: 24 }}>
                <h2>Luồng xử lý :</h2>
                <GatewayFlowDiagram />
            </div>
        </Layout>
    );
}
